// eslint-disable-next-line eslint-comments/disable-enable-pair
// https://lastbrand.atlassian.net/browse/ECOMP-4497
import { CONFIG_BUY_NOW_REDIR_DOMAIN } from '@src/config/env'

import { USER_ENTERED_ZIP_COOKIE_KEY, ZIP_COOKIE_KEY } from '../../hooks/zipcode/context/zipcode.context.provider'
import AuthUtil from '../../utils/authUtil'
import getCookie from '../../utils/getCookie'
import isBrowser from '../../utils/isBrowser'
import { TBuyNowApiResponse } from '../cartService/cart.service.types'

import { getOrCreateCheckout } from './cart.service'
import { getCheckoutWithId, getIsCheckoutActive } from './checkout.service'
import { removeCheckoutIdFromLocalStorage } from './checkout.service.helper'
import {
  CART_CHECKOUT_ID_KEY,
  CART_CHECKOUT_OBJ_KEY,
  LOCAL_STORAGE_CART_OBJ_KEY,
  LOCAL_STORAGE_NEW_CART_ID_KEY,
  LOCAL_STORAGE_PREV_CART_ID_KEY,
  LOCAL_STORAGE_PREV_CHECKOUT_ID_KEY,
} from './constants'

export const updateNewCheckoutInLocalStorage = (data: any) => {
  if (data?.id) {
    window.localStorage.setItem(LOCAL_STORAGE_NEW_CART_ID_KEY, data?.cart?.id || '')
    window.localStorage.setItem(LOCAL_STORAGE_CART_OBJ_KEY, JSON.stringify(data?.cart))
    window.localStorage.setItem(CART_CHECKOUT_ID_KEY, data.id || '')
    window.localStorage.setItem(CART_CHECKOUT_OBJ_KEY, JSON.stringify(data))
  }
}
export const getPrevCartId = () => {
  return window.localStorage.getItem(LOCAL_STORAGE_PREV_CART_ID_KEY)
}
export const deletePrevCartId = () => {
  window.localStorage.removeItem(LOCAL_STORAGE_PREV_CART_ID_KEY)
}
export const getCartId = () => {
  return window.localStorage.getItem(LOCAL_STORAGE_NEW_CART_ID_KEY)
}

export const getPrevCheckoutId = () => {
  return window.localStorage.getItem(LOCAL_STORAGE_PREV_CHECKOUT_ID_KEY)
}

export const deletePrevCheckoutId = () => {
  window.localStorage.removeItem(LOCAL_STORAGE_PREV_CHECKOUT_ID_KEY)
}

export const getZipCode = () => {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  return getCookie(USER_ENTERED_ZIP_COOKIE_KEY) || getCookie(ZIP_COOKIE_KEY)
}

export const getCheckoutId = () => {
  const checkoutId = localStorage.getItem(CART_CHECKOUT_ID_KEY)
  if (checkoutId) {
    return checkoutId
  }
  return null
}
export const getNewCheckoutFromLocalStorage = () => {
  let cartString: string | null = ''
  if (isBrowser()) {
    if (window.localStorage.getItem(LOCAL_STORAGE_NEW_CART_ID_KEY)) {
      cartString = window.localStorage.getItem(LOCAL_STORAGE_CART_OBJ_KEY)
    } else {
      window.localStorage.removeItem(LOCAL_STORAGE_CART_OBJ_KEY)
    }
  }
  let checkout
  if (cartString) {
    try {
      checkout = JSON.parse(cartString)
    } catch (error) {
      console.error('Error occured on getCheckoutFromLocalStorage: ', error)
    }
  }
  return checkout
}
export const getNewCartData = async () => {
  const isLoggedIn = AuthUtil.isLoggedIn()
  let result = []
  if (isLoggedIn) {
    let data
    try {
      data = await getIsCheckoutActive()
    } catch (error) {
      removeCheckoutIdFromLocalStorage()
      return
    }
    result = data
  } else {
    const checkoutId = getCheckoutId()
    const cartId = getCartId()
    if (checkoutId) {
      const data = await getCheckoutWithId(checkoutId)
      if (data.cartStatus !== 'ACTIVE') {
        removeCheckoutIdFromLocalStorage()
        return
      }
      result = data
    } else if (cartId) {
      const createdCheckout = await getOrCreateCheckout(cartId)
      const data = await getCheckoutWithId(createdCheckout?.checkoutId)
      if (data.cartStatus !== 'ACTIVE') {
        removeCheckoutIdFromLocalStorage()
        return
      }
      result = data
    }
  }
  return result
}

export const getCheckoutUrlFromBuyNowRes = (response: TBuyNowApiResponse | undefined) => {
  if (!response?.buyNowCartCheckoutMapping) return ''
  const {
    buyNowCartCheckoutMapping: { checkoutId, checkoutAuthCode },
  } = response

  if (!checkoutId || !checkoutAuthCode) return ''
  return `${CONFIG_BUY_NOW_REDIR_DOMAIN}/checkout?checkoutId=${checkoutId}&checkoutAuthCode=${checkoutAuthCode}`
}
